import { AbstractControl, ValidationErrors } from "@angular/forms";

export function emailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  const valid = emailRegex.test(control.value);
  return valid ? null : { email: true };
}
